import { render, staticRenderFns } from "./organizerInfo.vue?vue&type=template&id=2898f3a1&scoped=true&"
import script from "./organizerInfo.vue?vue&type=script&lang=js&"
export * from "./organizerInfo.vue?vue&type=script&lang=js&"
import style0 from "./organizerInfo.vue?vue&type=style&index=0&id=2898f3a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898f3a1",
  null
  
)

export default component.exports